import { useContext, useEffect, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";

export const useAwardCategories = ({ filterValues, setFilterValues, years }) => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [loader, setLoader] = useState({ btn: false });
    const [createCategory, setCreateCategory] = useState({ visible: false});
    const [categories, setCategories] = useState([]);
    const createCategoryFields = [
        {
            label: "Year",
            name: "year_id",
            col: "12",
            type: "select",
            option: years,
            optionLabel: "year_name",
            optionValue: "year_id",
            required: true,
            disabled: createCategory?.year_id
        },
        {
            label: "Category Name",
            name: "category_name",
            col: "12",
            type: "text",
            required: true,
        },
        {
            label: "Description",
            name: "category_descr",
            col: "12",
            type: "textarea",
            required: false,
        },
    ]

    useEffect(() => {
        (filterValues?.categoryApiCall && filterValues?.year?.year_id) && getCategories();
    }, [filterValues?.year, filterValues?.categoryApiCall])

    const getCategories = async () => {
        try {
            setLoader((prev) => ({ ...prev, data: true }));
            const res = await services.getInvokeRemote("POST", Urls("GETAWARDCATEGORIES"), { year_id: filterValues?.year?.year_id || 0 });
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.award_categories?.sort((a, b) => a?.category_name?.localeCompare(a?.category_name));
                setCategories(data);
                setFilterValues((prev) => ({...prev, categoryList: data}));
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, data: false }));
            setFilterValues((prev) => ({ ...prev, categoryApiCall: false }));
        }
    }

    const saveCategory = async () => {
        try {
            if(!filterValues?.year?.year_id) {
                showInfo("Info", "Please select the year");
                return;
            } else if (!createCategory?.category_name?.trim()) {
                showInfo("Info", "Please enter the category name");
                return;
            } else if (!createCategory?.isChange) {
                showInfo("Info", "No changes made");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            const payload = {
                category_id: createCategory?.category_id || 0,
                year_id: filterValues?.year?.year_id || "",
                category_name: createCategory?.category_name || "",
                category_descr: createCategory?.category_descr || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTAWARDCATEGORIES"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                setCreateCategory({ visible: false });
                getCategories();
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const deleteCategory = async () => {
        try {
            setLoader((prev) => ({ ...prev, delete: true }));
            const payload = {
                category_id: createCategory?.delete?.category?.category_id || 0,
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEAWARDCATEGORIES"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                setCategories((prev) => prev?.filter(cate => cate?.category_id !== createCategory?.delete?.category?.category_id));
                setFilterValues((prev) => ({...prev, categoryList: prev?.categoryList?.filter(cate => cate?.category_id !== createCategory?.delete?.category?.category_id)}));
                setCreateCategory({ visible: false });
            }
        } catch (error) {
            console.error("Error: ", error);
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader((prev) => ({ ...prev, delete: false }));
        }
    }

    return { categories, createCategory, setCreateCategory, createCategoryFields, saveCategory, loader, deleteCategory }
}